import {Button, Typography} from '@mui/material';
import noHospitalizationImage from 'presentation/assets/images/hospitalization.svg';
import {useAccountInformation, useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {ServicesEnum} from 'presentation/constants';
import {StyledCardContainer, StyledContent} from './styles';

const {title, action} = translations['pt-br'].privateFlow.myHospitalization.noHospitalization;

export const NoHospitalizationActive = () => {
	const navigate = useNavigate();
	const {isTablet} = useMediaQueries();
	const {firstNameBeneficiary} = useAccountInformation();

	return (
		<StyledCardContainer isMobile={isTablet}>
			<StyledContent>
				<Typography variant="h6">
					{title.replace('::beneficiaryName', firstNameBeneficiary)}
				</Typography>
				<Button onClick={() => navigate(ServicesEnum.SERVICES)}>{action}</Button>
			</StyledContent>
			<img
				width={222}
				height={222}
				src={noHospitalizationImage}
				alt="Enfermeira cuidando do paciente"
			/>
		</StyledCardContainer>
	);
};
